import { useEffect, useState } from 'react';
import { NEXT_PAGE_LOAD_PADDING } from 'themes/constants';

/**
 * Infinite scroll: calls onLoadMore when the element carrying the returned ref nears the viewport.
 * Render the element only while more pages exist; the observer follows its mount/unmount.
 */
export const useInfiniteScroll = (onLoadMore?: () => void) => {
  const [element, setElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!element) {
      return undefined;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          onLoadMore?.();
        }
      },
      { rootMargin: NEXT_PAGE_LOAD_PADDING },
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, [element, onLoadMore]);

  return setElement;
};
